const processDispatchStatus = ({ status }: { status: string }) => {
  const endpointParams: Record<
    'status' | 'refundStatus' | 'shippingStatus' | 'excludedRefundStatus',
    string
  > = {
    status: '',
    refundStatus: '',
    shippingStatus: '',
    excludedRefundStatus: '',
  };
  switch (status) {
    case 'ALL':
      endpointParams.status = 'CONFIRMED,COMPLETED';
      break;
    case 'DISPATCHED':
      endpointParams.status = 'CONFIRMED';
      endpointParams.shippingStatus = 'DISPATCHED';
      endpointParams.excludedRefundStatus = 'REFUNDED';
      break;
    case 'NOT_SHIPPED':
      endpointParams.status = 'CONFIRMED';
      endpointParams.shippingStatus = 'NOT_SHIPPED';
      endpointParams.excludedRefundStatus = 'REFUNDED';
      break;
    case 'PENDING_RENEWAL':
      endpointParams.status = 'CONFIRMED';
      endpointParams.shippingStatus = 'PENDING_RENEWAL';
      endpointParams.excludedRefundStatus = 'REFUNDED';
      break;
    default:
      endpointParams.status = status;
      break;
  }

  return endpointParams;
};

const getFormattedDispatchStatus = ({ item }: { item: any }) =>
  item.shippingStatus;

export { getFormattedDispatchStatus, processDispatchStatus };
